import { VidioHelpers } from 'shared/vidio_helpers';
import AhoyEvent from 'shared/ahoy_event';

export default class HomepageTracker {
  constructor(options) {
    this.$element = $(options.element);
    this.name = this.$element.data("name");
    this.recommender = this.$element.data("recommender");
    this.uuid = this.generateId();
  }

  init() {
    if (!HomepageTracker.listenerRegistered) {
      HomepageTracker.listenerRegistered = true;
      $(window).on('scroll', HomepageTracker.scrollListener);
    }
    HomepageTracker.instances.push(this);
    HomepageTracker.scrollListener(); // try to send immediately if already visible
    this.addUuidToDom();
    this.bindAhoyEventHeaderClick();
  }

  sendImpression() {
    AhoyEvent.send("HOME::SECTION::GET", this.generateProperties());
  }

  hasBeenShown(maximumYOffset) {
    var offsetTop = this.$element.offset().top;
    var maximumWindowBottomOffset = maximumYOffset + window.innerHeight;
    return maximumWindowBottomOffset > offsetTop;
  }

  getItems() {
     var video_items = this.$element.find("[data-video-id]");
     var items = [];
     video_items.each(function (index, object) {
       var itemProperties = {
         video_id: $(object).data("video-id"),
         position: $(object).data("position"),
         item_type: $(object).data("item-type")
       };
       var recommender = $(object).data("recommender");
       if (recommender) {
         itemProperties.recommender = recommender;
       }
       items.push(itemProperties);
     });
     return items;
  }

  bindAhoyEventHeaderClick() {
    this.$element.find("[data-event='ctr_head_tracker']").on("click", () => {
      this.sendHeaderConversion("title");
    });

    this.$element.find("[data-event='ctr_see_all_tracker']").on("click", () => {
      this.sendHeaderConversion("see_all");
    });
  }

  sendHeaderConversion(clickable) {
    var properties = {
      platform: VidioHelpers.getPlatform(),
      section: this.name,
      app_name: "vidio",
      clickable: clickable,
      section_position: this.getPosition(),
      page_name: 'home'
    };
    AhoyEvent.send("HOME::SECTION::HEADER", properties);
  }

  generateProperties(){
    var properties = {
      uuid: this.uuid,
      platform: VidioHelpers.getPlatform(),
      section: this.name,
      app_name: "vidio",
      items: this.getItems(),
      section_position: this.getPosition(),
      page_name: 'home',
      recommender: this.recommender
    };

    return properties;
  }

  getPosition() {
    var component = this.$element;
    if (!component.data("name").startsWith("popular_categories_")) {
      return -1;
    }
    return $('[data-component="HomepageTracker"][data-name^="popular_categories_"]').index(component);
  }
  
  // http://stackoverflow.com/a/8809472
  generateId() {
    var d = new Date().getTime();
    var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = (d + Math.random()*16)%16 | 0;
        d = Math.floor(d/16);
        return (c=='x' ? r : (r&0x3|0x8)).toString(16);
    });
    return uuid;
  }

  addUuidToDom(){
    this.$element.attr('data-uuid', this.uuid);
  }
}

HomepageTracker.maxTop = 0;
HomepageTracker.instances = [];
HomepageTracker.listenerRegistered = 0;
HomepageTracker.scrollListener = function() {
  var supportPageOffset = window.pageXOffset !== undefined;
  var isCSS1Compat = ((document.compatMode || "") === "CSS1Compat");
  var y = supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop;

  HomepageTracker.maxTop = Math.max(HomepageTracker.maxTop, y);
  var instances = HomepageTracker.instances;

  for (var i = 0; i < instances.length; i++) {
    if (instances[i].hasBeenShown(HomepageTracker.maxTop)) {
      instances[i].sendImpression();
      instances.splice(i, 1);
      i--;
    }
  }
};
